import { GlIcon, GlLink } from '@gitlab/ui';
import { uniqueId } from 'lodash-es';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { titleInLinkSafeHtmlConfig } from '~/lib/dompurify';
import WorkItemPopover from '~/issuable/popover/components/work_item_popover.vue';
export default {
    name: 'WorkItemParentMetadata',
    components: {
        GlIcon,
        GlLink,
        WorkItemPopover
    },
    directives: {
        SafeHtml
    },
    titleInLinkSafeHtmlConfig,
    props: {
        parent: {
            type: Object,
            required: true
        },
        iconSize: {
            type: Number,
            required: false,
            default: 16
        }
    },
    data () {
        return {
            linkId: uniqueId('work-item-parent-metadata-link-')
        };
    },
    computed: {
        parentWebUrl () {
            return this.parent?.webUrl;
        },
        parentTitle () {
            return this.parent?.title;
        },
        parentTitleHtml () {
            return this.parent?.titleHtml;
        },
        parentIid () {
            return this.parent?.iid || '';
        },
        parentNamespace () {
            return this.parent?.namespace?.fullPath || '';
        }
    }
};
